import React, { useEffect, useRef, useState } from 'react'
import { useDispatch } from 'react-redux'
import { signUp } from '../../features/user'
import { useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import { NavLink } from 'react-router-dom';

export default function SignUnForm() {
    const [sending, setSending] = useState(false)
    const dispatch = useDispatch()
    // select user
    // const user = useSelector((state) => state.user.value);
    // form data
    const { register, handleSubmit, formState: { errors }, watch, getValues, reset
    } = useForm();
    const [data, setData] = useState("");
    // compare passwords 
    const password = useRef({});
    password.current = watch("password", "");
    // compare passwords end
    const onSubmit = async data => {
        setSending(true)
        setData(JSON.stringify(data));
    };

    useEffect(() => {
        // if data save data
        if (data) {
            // hide loader
            setSending(false)
            // hide loader end
            // add data to store
            dispatch(signUp({ firstName: getValues("firstName"), lastName: getValues("lastName"), email: getValues("email"), phone: getValues("phone"), password: getValues("password"), accept: getValues("acceptTerms") }))
            // add data to store end
            // reset value if success
            reset({
                firstName: "",
                lastName: "",
                email: "",
                phone: "",
                password: "",
                password_repeat: "",
                acceptTerms: ""
            })
        }
    }, [data])

    // useEffect(() => {
    //     console.log('user', user);
    // }, [user])
    return (
        <div className='text-black'>
            <form onSubmit={handleSubmit((data) => onSubmit(data))}>
                <div>
                    <div className="flex md:flex-row flex-col mb-4">
                        <div className="w-full md:w-1/2 md:mr-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="first_name">First Name *</label>
                            <input className="input-field" type="text" placeholder="first name" {...register("firstName", {
                                required: true
                            })} id="first_name" />
                            {errors.firstName && <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">This field is required</span>}
                        </div>
                        <div className="w-full md:w-1/2 md:ml-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="last_name">Last Name *</label>
                            <input className="input-field" id="last_name" type="text"  {...register("lastName", {
                                required: true
                            })} placeholder="last name" />

                            {errors.lastName && <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">This field is required</span>}
                        </div>
                    </div>
                    <div className="flex md:flex-row flex-col mb-4">
                        <div className="w-full md:w-1/2 md:mr-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="email">Email *</label>
                            <input className="input-field" type="text" {...register("email", {
                                required: "This field is required",
                                pattern: {
                                    value: /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i,
                                    message: "Email format is incorrect"
                                }
                            })} placeholder="email" id="email" />
                            {errors.email ? (
                                <>
                                    {/* required error message  */}
                                    {errors.email.type === "required" && (
                                        <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                            {errors.email.message}
                                        </span>
                                    )}
                                    {/* format error message  */}

                                    {errors.email.type === "pattern" && (
                                        <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                            {errors.email.message}
                                        </span>
                                    )}
                                </>
                            ) : null}
                        </div>
                        <div className="w-full md:w-1/2 md:ml-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="phone">Phone *</label>
                            <input className="input-field" id="phone" type="text" {...register("phone", {
                                required: "This field is required",
                                pattern: {
                                    value: /^[\+]?[(]?[0-9]{3}[)]?[-\s\.]?[0-9]{3}[-\s\.]?[0-9]{4,6}$/im,
                                    message: "Phone format is incorrect"
                                }
                            })} placeholder="phone" />
                            {errors.phone ? (
                                <>
                                    {/* required error message  */}
                                    {errors.phone.type === "required" && (
                                        <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                            {errors.phone.message}
                                        </span>
                                    )}
                                    {/* format error message  */}

                                    {errors.phone.type === "pattern" && (
                                        <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">
                                            {errors.phone.message}
                                        </span>
                                    )}
                                </>
                            ) : null}
                        </div>
                    </div>

                    <div className="flex md:flex-row flex-col mb-4">
                        <div className="w-full md:w-1/2 md:mr-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="password">Password *</label>
                            <input className="input-field" type="password"  {...register("password", {
                                required: "You must specify a password",
                                minLength: {
                                    value: 8,
                                    message: "Password must have at least 8 characters"
                                }
                            })} placeholder="password" id="password" />
                            {errors.password && <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">{errors.password.message}</span>}
                        </div>
                        <div className="w-full md:w-1/2 md:ml-[0.625rem] pb-4 relative">
                            <label className="input-label" htmlFor="repeatPassword">Repeat Password *</label>
                            <input className="input-field" id="repeatPassword" type="password" {...register("password_repeat", {
                                validate: value =>
                                    value === password.current || "The passwords do not match"
                            })} placeholder="repeatPassword" />
                            {errors.password_repeat && <span className="text-formSubSize absolute -bottom-[0.5rem] right-0 text-[#CA0000] pt-1 ">{errors.password_repeat.message}</span>}
                        </div>

                    </div>
                    <div className="flex pt-14 pb-5 relative">
                        <label className="containerCheckbox">
                            <input type="checkbox" className="checkbox" {...register('acceptTerms', {
                                required: true,
                            })} />
                            <span className="text-formSubSize text-white ">I Accept <NavLink to="/" className="text-mainColor">Terms & Condition</NavLink></span>
                            <span className="checkMark"></span>
                        </label>
                        {errors.acceptTerms && <span className="text-formSubSize absolute -bottom-[-0.1rem] left-0 text-[#CA0000] pt-1 ">This field is required</span>}
                    </div>
                </div>
                {
                    // if we are sending data show loader
                    sending ?
                        <div className="main-button w-fit">
                            <svg className="animate-spin -ml-1 mr-3 h-5 w-5 text-black" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                            </svg>
                        </div> :
                        // after or before send
                        <input type="submit" value={"Create Account"} className="main-button" />
                }
                <div className="text-formSubSize text-white pt-5"> Already a Member? Sign in <NavLink to="/" className="text-mainColor">here.</NavLink></div>
            </form>
        </div>
    )
}
